import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SignatureTester from '../../components/qztray/signature/SignatureTester';

/**
 * ✍️ Página: Firma Digital QZ Tray
 */
const QzTraySignature = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SignatureTester />
    </DefaultLayout>
  );
};

export default QzTraySignature;
